import COLORS from '@/pages/Metrics/configs/colors';

const campaignStatusChartConfig = {
  name: 'campaign_status_counts',
  title: 'Campaign status counts',
  metric: 'campaign_status_counts',
  helpText: 'The <i>Campaign Status Counts</i> graph shows the total number of campaigns for each status during the selected date range.',
  lines: {
    executed_count: {
      label: 'Completed',
      position: 1,
      color: COLORS.grass,
    },
    deleted_count: {
      label: 'Deleted',
      position: 2,
      color: COLORS.yellow,
    },
    stopped_count: {
      label: 'Stopped',
      position: 3,
      color: COLORS.blood_red,
    },
    pending_count: {
      label: 'Pending',
      position: 4,
      color: COLORS.blue,
    },
    failed_count: {
      label: 'Failed',
      position: 5,
      color: COLORS.orange,
    },
    total: {
      label: 'Total Unique Campaigns',
      position: 6,
      color: COLORS.medium_turquoise,
      type: 'spline',
    },
  },
};

export default campaignStatusChartConfig;
